import React from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {DateRange} from 'rsuite/DateRangePicker';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import DateRangePickerControlled from 'shared/ui/Date/DateRangePickerControlled/DateRangePickerControlled';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import {dateRangeToFilters, getUrlDateRange, UrlFiltersData} from 'shared/lib/filterHelper';
import {getActiveOptions} from 'shared/lib/filterOptions';
import {getUserReportPeriodLabel, USER_REPORT_PERIODS} from 'features/userReports/lib/userReportFilters';

interface IUserReportsFiltersForm {
    isActive?: string,
    period?: string,
    createdAt?: DateRange,
    lastSentAt?: DateRange,
}

const UserReportsFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();

    const {handleSubmit, control} = useForm<IUserReportsFiltersForm>({
        defaultValues: {
            isActive: searchParams.get('is_active') ?? undefined,
            period: searchParams.get('period') ?? undefined,
            createdAt: getUrlDateRange(searchParams, 'created_at'),
            lastSentAt: getUrlDateRange(searchParams, 'last_sent_at'),
        },
    });

    const periodOptions = USER_REPORT_PERIODS.map(period => ({label: getUserReportPeriodLabel(period), value: period}));

    const toFilters = ({isActive, period, createdAt, lastSentAt}: IUserReportsFiltersForm) => {
        const data: UrlFiltersData = {
            is_active: isActive ?? undefined,
            period: period ?? undefined,
        };
        dateRangeToFilters(createdAt, data, 'created_at');
        dateRangeToFilters(lastSentAt, data, 'last_sent_at');

        return data;
    };

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Статус`}>
                <Select
                    control={control}
                    name="isActive"
                    data={getActiveOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Период`}>
                <Select control={control} name="period" data={periodOptions} cleanable={true} searchable={false}/>
            </FormGroupWithError>

            <FormGroupWithError label={t`Период создания`}>
                <DateRangePickerControlled control={control} name="createdAt" cleanable={true}/>
            </FormGroupWithError>

            <FormGroupWithError label={t`Период последней отправки`}>
                <DateRangePickerControlled control={control} name="lastSentAt" cleanable={true}/>
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default UserReportsFiltersForm;
